import {
  XMarkIcon,
  CheckIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { cn } from "@/lib/utils";

type Size = "default" | "small";

type Feature = {
  title: string;
  description: string;
}[];

interface PriceListProps {
  features: Feature;
  excludedFeatures?: Feature;
  size?: Size;
}

const sizeVariants = {
  default: {
    title: "text-base",
    list: "gap-3",
  },
  small: {
    title: "text-xs",
    list: "gap-2",
  },
} satisfies Record<Size, { title: string; list: string }>;

export const PriceList = ({
  size = "default",
  features,
  excludedFeatures,
}: PriceListProps) => {
  return (
    <ul className={cn(sizeVariants[size].list, "flex flex-col w-full")}>
      {features.map((item, index) => (
        <li
          key={index}
          className={cn(sizeVariants[size].title, "flex items-center gap-2")}
        >
          <CheckIcon className="w-5 h-5 text-green-500 mr-1" />
          <h3>{item.title}</h3>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                className="bg-transparent border-none"
                aria-label={item.description}
              >
                <InformationCircleIcon className="w-4 h-4 text-muted-foreground" />
              </button>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-sm font-semibold">{item.description}</p>
            </TooltipContent>
          </Tooltip>
        </li>
      ))}
      {excludedFeatures?.map((item, index) => (
        <li
          key={index}
          className={cn(sizeVariants[size].title, "flex items-center gap-2")}
        >
          <XMarkIcon className="w-5 h-5 text-red-500 mr-1" />
          <span className="text-muted-foreground">{item.title}</span>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                className="bg-transparent border-none"
                aria-label={item.description}
              >
                <InformationCircleIcon className="w-4 h-4 text-muted-foreground" />
              </button>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-sm font-semibold">{item.description}</p>
            </TooltipContent>
          </Tooltip>
        </li>
      ))}
    </ul>
  );
};
